import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  walletConnectWallet,
  coinbaseWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { bsc } from 'wagmi/chains';
import { http } from 'wagmi';

// WalletConnect Cloud project ID — enables WalletConnect + mobile wallets.
const WC_PROJECT_ID =
  process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'e4da357c0c533846da5ba1a1ade584ce';

// Paid Alchemy RPC from env; falls back to a public BSC node.
const BSC_RPC = process.env.REACT_APP_BSC_RPC || 'https://bsc-dataseed.binance.org/';

// NOTE: deliberately NOT using RainbowKit's `metaMaskWallet` connector — it pulls
// in `@metamask/sdk` → `@metamask/sdk-analytics` → `openapi-fetch`, whose ESM/CJS
// interop breaks under CRA's Webpack 5 ("import_openapi_fetch.default is not a
// function"). `injectedWallet` connects to the MetaMask extension via
// window.ethereum directly (no SDK); mobile is covered by WalletConnect.
export const wagmiConfig = getDefaultConfig({
  appName: 'Ginox Admin Panel',
  projectId: WC_PROJECT_ID,
  chains: [bsc],
  wallets: [
    {
      groupName: 'Popular',
      wallets: [injectedWallet, walletConnectWallet, coinbaseWallet],
    },
  ],
  transports: {
    [bsc.id]: http(BSC_RPC),
  },
  ssr: false,
});
